var _defs, _g, _rect, _defs2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTableFormatPreview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 177,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "d",
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h300v36.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    fill: "#fff",
    d: "M0 0h300v35.01H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 176.05,
    fill: "#fff",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBDFEC",
    d: "M0 0h60v36.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M.5-5000V5000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424768",
    d: "M16.08 18.64a4.9 4.9 0 0 1-.54 2.42 3.46 3.46 0 0 1-1.56 1.46c-.69.33-1.51.49-2.48.49H9.12v-8.57h2.64c.89 0 1.65.16 2.3.48.64.32 1.14.8 1.5 1.42.34.62.52 1.39.52 2.3Zm-1.46.05a4 4 0 0 0-.34-1.74 2.14 2.14 0 0 0-.97-1 3.37 3.37 0 0 0-1.58-.34h-1.2v6.22h1c1.03 0 1.8-.26 2.32-.79.5-.53.77-1.31.77-2.35Zm5.7-2.29c.83 0 1.45.18 1.87.55.42.36.63.93.63 1.7V23h-.98l-.26-.92h-.05c-.18.23-.37.43-.57.58-.2.15-.42.27-.68.34a3.2 3.2 0 0 1-1.97-.1c-.3-.14-.54-.36-.72-.65a2.2 2.2 0 0 1-.26-1.11c0-.67.25-1.17.74-1.5.5-.35 1.26-.53 2.26-.57l1.13-.04v-.34c0-.45-.1-.77-.32-.96-.2-.19-.5-.28-.88-.28-.32 0-.64.04-.94.14-.3.09-.6.2-.89.34l-.45-.97a5 5 0 0 1 2.35-.57Zm1.13 3.51-.83.03c-.7.02-1.17.14-1.45.35-.28.21-.42.5-.42.87 0 .32.1.55.29.7.2.15.44.22.75.22.48 0 .88-.14 1.19-.4.31-.28.47-.68.47-1.2v-.57Zm5.71 2.1a3.05 3.05 0 0 0 1.01-.17v1.05a3.97 3.97 0 0 1-1.35.24c-.36 0-.7-.06-.98-.18-.3-.13-.53-.34-.7-.64-.17-.3-.26-.72-.26-1.25v-3.49H24v-.61l.95-.49.45-1.39h.86v1.44h1.86v1.05h-1.86v3.47c0 .33.09.57.25.73a.9.9 0 0 0 .65.24Zm4.88-5.61c.82 0 1.43.18 1.85.55.42.36.64.93.64 1.7V23h-.98l-.27-.92h-.04c-.19.23-.38.43-.57.58-.2.15-.42.27-.68.34a3.2 3.2 0 0 1-1.97-.1c-.3-.14-.55-.36-.72-.65a2.1 2.1 0 0 1-.26-1.11c0-.67.24-1.17.74-1.5.5-.35 1.25-.53 2.26-.57l1.13-.04v-.34c0-.45-.11-.77-.32-.96-.2-.19-.5-.28-.88-.28-.32 0-.64.04-.94.14-.3.09-.6.2-.9.34l-.44-.97a5 5 0 0 1 2.35-.57Zm1.12 3.51-.84.03c-.69.02-1.17.14-1.45.35-.27.21-.41.5-.41.87 0 .32.1.55.29.7.19.15.44.22.75.22.48 0 .87-.14 1.19-.4.31-.28.47-.68.47-1.2v-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBDFEC",
    d: "M60 0h60v36.01H60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M60.5-5000V5000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424768",
    d: "M76.31 16.4c.73 0 1.28.19 1.65.56.37.38.55.98.55 1.8v4.25h-1.38v-4c0-.49-.1-.86-.28-1.11-.2-.25-.48-.37-.88-.37-.54 0-.94.17-1.18.52s-.36.86-.36 1.52v3.44h-1.37v-4c0-.32-.05-.6-.13-.82a.96.96 0 0 0-.38-.5 1.16 1.16 0 0 0-.65-.16c-.38 0-.69.08-.91.25-.22.18-.38.43-.48.76-.1.34-.15.75-.15 1.23v3.24h-1.38v-6.49h1.08l.19.88h.08c.13-.23.3-.42.49-.56.2-.15.42-.26.66-.33.24-.07.5-.11.76-.11.48 0 .89.09 1.22.26.33.17.58.42.75.77h.1c.2-.35.49-.61.85-.78.36-.17.75-.25 1.15-.25Zm9.87 3.35a4.5 4.5 0 0 1-.22 1.44 2.71 2.71 0 0 1-1.59 1.72 3.61 3.61 0 0 1-2.5-.01 2.8 2.8 0 0 1-1.6-1.71c-.14-.42-.22-.9-.22-1.44 0-.71.13-1.32.37-1.81.25-.5.6-.89 1.07-1.15.46-.26 1-.39 1.64-.39.6 0 1.13.13 1.59.4.45.25.81.64 1.07 1.14.26.5.39 1.1.39 1.81Zm-4.7 0c0 .47.05.88.16 1.21.12.34.3.6.54.78.24.17.55.26.94.26.38 0 .7-.09.93-.26.25-.18.42-.44.54-.78.11-.33.17-.74.17-1.2 0-.48-.06-.88-.17-1.2-.12-.34-.3-.6-.54-.77a1.57 1.57 0 0 0-.94-.26c-.57 0-.98.2-1.25.58a2.9 2.9 0 0 0-.39 1.64Zm8.9 3.38c-.62 0-1.15-.12-1.6-.36a2.4 2.4 0 0 1-1.04-1.1 4.24 4.24 0 0 1-.36-1.87c0-.79.13-1.43.4-1.93.26-.5.63-.87 1.1-1.11a4.33 4.33 0 0 1 3.47.04l-.4 1.1c-.25-.1-.5-.19-.74-.25a2.8 2.8 0 0 0-.72-.1c-.38 0-.7.08-.95.25a1.5 1.5 0 0 0-.56.75c-.12.33-.19.74-.19 1.24 0 .47.07.88.2 1.2.12.33.3.57.55.74.25.17.55.25.9.25a3.27 3.27 0 0 0 1.76-.46v1.2c-.25.13-.51.24-.8.3-.27.07-.62.1-1.03.1Zm10.06-.12h-1.38V17.5a25.94 25.94 0 0 1 .05-1.6c-.08.1-.19.19-.3.3l-.38.32-.99.79-.69-.87 2.54-2h1.15v8.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBDFEC",
    d: "M120 0h60v36.01h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M120.5-5000V5000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424768",
    d: "M136.31 16.4c.73 0 1.28.19 1.65.56.37.38.55.98.55 1.8v4.25h-1.38v-4c0-.49-.1-.86-.28-1.11-.2-.25-.48-.37-.88-.37-.54 0-.94.17-1.18.52s-.36.86-.36 1.52v3.44h-1.37v-4c0-.32-.05-.6-.13-.82a.96.96 0 0 0-.38-.5 1.16 1.16 0 0 0-.65-.16c-.38 0-.69.08-.91.25-.22.18-.39.43-.48.76-.1.34-.15.75-.15 1.23v3.24h-1.38v-6.49h1.08l.19.88h.08c.13-.23.3-.42.49-.56.2-.15.42-.26.66-.33.24-.07.5-.11.76-.11.48 0 .89.09 1.22.26.33.17.58.42.75.77h.1c.2-.35.49-.61.85-.78.36-.17.75-.25 1.15-.25Zm9.87 3.35c0 .54-.08 1.02-.22 1.44a2.71 2.71 0 0 1-1.59 1.72 3.61 3.61 0 0 1-2.5-.01 2.8 2.8 0 0 1-1.6-1.71c-.14-.42-.22-.9-.22-1.44 0-.71.13-1.32.37-1.81.25-.5.6-.89 1.07-1.15.46-.26 1-.39 1.64-.39.6 0 1.13.13 1.59.4.45.25.81.64 1.07 1.14.26.5.39 1.1.39 1.81Zm-4.7 0c0 .47.05.88.16 1.21.12.34.3.6.54.78.24.17.55.26.94.26.38 0 .7-.09.94-.26.24-.18.41-.44.53-.78.11-.33.17-.74.17-1.2 0-.48-.06-.88-.17-1.2-.12-.34-.3-.6-.53-.77a1.57 1.57 0 0 0-.95-.26c-.57 0-.99.2-1.25.58a2.9 2.9 0 0 0-.39 1.64Zm8.9 3.38c-.62 0-1.15-.12-1.6-.36a2.4 2.4 0 0 1-1.04-1.1 4.25 4.25 0 0 1-.36-1.87c0-.79.13-1.43.4-1.93.26-.5.63-.87 1.1-1.11a4.33 4.33 0 0 1 3.47.04l-.4 1.1c-.25-.1-.5-.19-.74-.25a2.8 2.8 0 0 0-.72-.1c-.38 0-.7.08-.95.25a1.5 1.5 0 0 0-.56.75 3.4 3.4 0 0 0-.19 1.24c0 .47.07.88.2 1.2.12.33.3.57.55.74.25.17.55.25.9.25a3.26 3.26 0 0 0 1.76-.46v1.2c-.25.13-.51.24-.8.3-.27.07-.62.1-1.03.1Zm11.81-.12h-5.8v-1.04l2.23-2.25c.42-.43.78-.81 1.06-1.13.27-.32.48-.62.61-.9.14-.3.2-.6.2-.94 0-.41-.11-.72-.35-.94a1.36 1.36 0 0 0-.94-.32c-.38 0-.72.08-1.04.22-.3.15-.63.36-.97.63l-.75-.91c.23-.2.49-.4.76-.56a3.73 3.73 0 0 1 2.06-.55c.54 0 1.01.1 1.4.3a2.12 2.12 0 0 1 1.24 2c0 .46-.1.88-.28 1.27-.18.4-.44.78-.78 1.16-.34.38-.75.8-1.22 1.24l-1.48 1.45v.06h4.06v1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBDFEC",
    d: "M180 0h60v36.01h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M180.5-5000V5000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424768",
    d: "M196.31 16.4c.73 0 1.28.19 1.65.56.37.38.55.98.55 1.8v4.25h-1.38v-4c0-.49-.1-.86-.28-1.11-.2-.25-.48-.37-.88-.37-.54 0-.94.17-1.18.52s-.36.86-.36 1.52v3.44h-1.37v-4c0-.32-.05-.6-.13-.82a.96.96 0 0 0-.38-.5 1.16 1.16 0 0 0-.65-.16c-.38 0-.69.08-.91.25-.22.18-.39.43-.48.76-.1.34-.15.75-.15 1.23v3.24h-1.38v-6.49h1.08l.19.88h.08c.13-.23.3-.42.49-.56.2-.15.42-.26.66-.33.24-.07.5-.11.76-.11.48 0 .89.09 1.22.26.33.17.58.42.75.77h.1c.2-.35.49-.61.85-.78.36-.17.75-.25 1.15-.25Zm9.87 3.35c0 .54-.08 1.02-.22 1.44a2.71 2.71 0 0 1-1.59 1.72 3.61 3.61 0 0 1-2.5-.01 2.8 2.8 0 0 1-1.6-1.71c-.14-.42-.22-.9-.22-1.44 0-.71.13-1.32.37-1.81.25-.5.6-.89 1.07-1.15.46-.26 1-.39 1.64-.39.6 0 1.13.13 1.59.4.45.25.81.64 1.07 1.14.26.5.39 1.1.39 1.81Zm-4.7 0c0 .47.05.88.16 1.21.12.34.3.6.54.78.24.17.55.26.94.26.38 0 .7-.09.94-.26.24-.18.41-.44.53-.78.11-.33.17-.74.17-1.2 0-.48-.06-.88-.17-1.2-.12-.34-.3-.6-.53-.77a1.57 1.57 0 0 0-.95-.26c-.57 0-.99.2-1.25.58a2.9 2.9 0 0 0-.39 1.64Zm8.9 3.38c-.62 0-1.15-.12-1.6-.36a2.4 2.4 0 0 1-1.04-1.1 4.25 4.25 0 0 1-.36-1.87c0-.79.13-1.43.4-1.93.26-.5.63-.87 1.1-1.11a4.33 4.33 0 0 1 3.47.04l-.4 1.1c-.25-.1-.5-.19-.74-.25a2.8 2.8 0 0 0-.72-.1c-.38 0-.7.08-.95.25a1.5 1.5 0 0 0-.56.75 3.4 3.4 0 0 0-.19 1.24c0 .47.07.88.2 1.2.12.33.3.57.55.74.25.17.55.25.9.25a3.26 3.26 0 0 0 1.76-.46v1.2c-.25.13-.51.24-.8.3-.27.07-.62.1-1.03.1Zm11.49-6.73a1.98 1.98 0 0 1-.88 1.71c-.27.18-.58.31-.94.39v.04c.68.09 1.2.3 1.55.64.35.35.53.8.53 1.37 0 .5-.12.94-.36 1.33-.24.39-.6.69-1.1.91-.49.23-1.12.34-1.9.34a5.42 5.42 0 0 1-2.42-.47v-1.23a5.45 5.45 0 0 0 2.33.57c.72 0 1.22-.14 1.53-.4.3-.27.46-.64.46-1.12 0-.3-.08-.55-.24-.75-.16-.2-.4-.34-.74-.44-.32-.1-.75-.14-1.27-.14h-.75v-1.1h.76c.5 0 .9-.07 1.2-.18.3-.13.51-.3.64-.5.14-.21.2-.46.2-.74 0-.37-.11-.65-.35-.86-.24-.2-.6-.3-1.06-.3a2.94 2.94 0 0 0-1.44.34c-.2.1-.39.22-.57.33l-.66-.95a4.64 4.64 0 0 1 2.73-.87c.88 0 1.56.19 2.03.57.48.37.72.88.72 1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DBDFEC",
    d: "M240 0h60v36.01h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M240.5-5000V5000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424768",
    d: "M256.31 16.4c.73 0 1.28.19 1.64.56.38.38.56.98.56 1.8v4.25h-1.38v-4c0-.49-.1-.86-.28-1.11-.2-.25-.49-.37-.88-.37-.54 0-.94.17-1.18.52s-.36.86-.36 1.52v3.44h-1.37v-4c0-.32-.05-.6-.13-.82a.96.96 0 0 0-.38-.5 1.16 1.16 0 0 0-.65-.16c-.38 0-.69.08-.91.25-.22.18-.39.43-.48.76-.1.34-.15.75-.15 1.23v3.24h-1.38v-6.49h1.08l.19.88h.08c.13-.23.3-.42.49-.56.2-.15.42-.26.66-.33.24-.07.5-.11.76-.11.48 0 .89.09 1.22.26.33.17.58.42.75.77h.1c.2-.35.49-.61.85-.78.36-.17.75-.25 1.15-.25Zm9.87 3.35c0 .54-.07 1.02-.22 1.44a2.71 2.71 0 0 1-1.59 1.72 3.61 3.61 0 0 1-2.5-.01 2.8 2.8 0 0 1-1.6-1.71c-.14-.42-.22-.9-.22-1.44 0-.71.13-1.32.37-1.81.25-.5.6-.89 1.07-1.15.46-.26 1-.39 1.64-.39.6 0 1.13.13 1.59.4.45.25.81.64 1.07 1.14.26.5.39 1.1.39 1.81Zm-4.7 0c0 .47.05.88.16 1.21.12.34.3.6.54.78.24.17.55.26.94.26.38 0 .7-.09.94-.26.24-.18.42-.44.53-.78.11-.33.17-.74.17-1.2 0-.48-.06-.88-.17-1.2-.11-.34-.3-.6-.53-.77a1.57 1.57 0 0 0-.95-.26c-.57 0-.99.2-1.25.58a2.9 2.9 0 0 0-.39 1.64Zm8.9 3.38c-.62 0-1.15-.12-1.6-.36a2.4 2.4 0 0 1-1.04-1.1 4.25 4.25 0 0 1-.36-1.87c0-.79.13-1.43.4-1.93.26-.5.63-.87 1.1-1.11a4.33 4.33 0 0 1 3.47.04l-.4 1.1c-.25-.1-.5-.19-.74-.25a2.8 2.8 0 0 0-.72-.1c-.38 0-.7.08-.95.25a1.5 1.5 0 0 0-.56.75 3.4 3.4 0 0 0-.19 1.24c0 .47.07.88.2 1.2.12.33.3.57.55.74.25.17.55.25.9.25a3.26 3.26 0 0 0 1.76-.46v1.2c-.25.13-.51.24-.8.3-.27.07-.62.1-1.03.1Zm12.13-2h-1.16V23h-1.36v-1.88h-3.9v-1.04l3.91-5.67h1.35v5.57h1.16v1.14Zm-2.52-1.14v-2.13a23.96 23.96 0 0 1 .07-1.88H280a9.09 9.09 0 0 1-.53.95l-2.11 3.06h2.62Z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 36.01h300v35.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 36.01h60v35.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M.5-4963.99v10000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M60 36.01h60v35.01H60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M60.5-4963.99v10000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M120 36.01h60v35.01h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M120.5-4963.99v10000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M180 36.01h60v35.01h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M180.5-4963.99v10000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M240 36.01h60v35.01h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M240.5-4963.99v10000"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 71.02h300v35H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 71.02h60v35H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M.5-4928.98v10000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M60 71.02h60v35H60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M60.5-4928.98v10000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M120 71.02h60v35h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M120.5-4928.98v10000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M180 71.02h60v35h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M180.5-4928.98v10000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M240 71.02h60v35h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M240.5-4928.98v10000"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)",
    filter: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 106.03h300v35.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 106.03h60v35.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M.5-4893.97v10000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M60 106.03h60v35.01H60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M60.5-4893.97v10000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M120 106.03h60v35.01h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M120.5-4893.97v10000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M180 106.03h60v35.01h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M180.5-4893.97v10000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M240 106.03h60v35.01h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M240.5-4893.97v10000"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)",
    filter: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 141.04h300v35.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 141.04h60v35.01H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M.5-4858.96v10000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M60 141.04h60v35.01H60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M60.5-4858.96v10000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M120 141.04h60v35.01h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M120.5-4858.96v10000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M180 141.04h60v35.01h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M180.5-4858.96v10000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M240 141.04h60v35.01h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDFEC",
    d: "M240.5-4858.96v10000"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 299,
    height: 175.05,
    x: 0.5,
    y: 0.5,
    stroke: "#DBDFEC",
    rx: 3.5
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 176.05,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    transform: "translate(0 36.01)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    transform: "translate(0 71.02)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    transform: "translate(0 106.03)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    transform: "translate(0 141.04)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 300,
    height: 36.01,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.72549 0 0 0 0 0.72549 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_466_4105"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: 300,
    height: 35.01,
    x: 0,
    y: 36.01,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.72549 0 0 0 0 0.72549 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_466_4105"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    width: 300,
    height: 35.01,
    x: 0,
    y: 71.02,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.72549 0 0 0 0 0.72549 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_466_4105"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    width: 300,
    height: 35.01,
    x: 0,
    y: 106.03,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.72549 0 0 0 0 0.72549 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_466_4105"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "l",
    width: 300,
    height: 35.01,
    x: 0,
    y: 141.04,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.72549 0 0 0 0 0.72549 0 0 0 0 0.72549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_466_4105"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableFormatPreview);
export default __webpack_public_path__ + "static/media/table-format-preview.32a6b11b5e47c8b6abde6763e28c3591.svg";
export { ForwardRef as ReactComponent };